import { render, staticRenderFns } from "./Waimai.vue?vue&type=template&id=6ed32163&scoped=true"
import script from "./Waimai.vue?vue&type=script&lang=js"
export * from "./Waimai.vue?vue&type=script&lang=js"
import style0 from "./Waimai.vue?vue&type=style&index=0&id=6ed32163&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed32163",
  null
  
)

export default component.exports